export class ConnectGoogleWorkspaceRequest {
    'domain';
    'delegatedAdminEmail';
    'serviceAccountEmail';
    'managementProjectId';
    'displayName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        },
        {
            "name": "delegatedAdminEmail",
            "baseName": "delegatedAdminEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceAccountEmail",
            "baseName": "serviceAccountEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementProjectId",
            "baseName": "managementProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectGoogleWorkspaceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
